import React from 'react'
import Select from "../../../ui/select";

const CurrencySelect = ({ options, onSelect, selectedCurrency, label }) => (
  <Select
    className="СurrencySelect"
    options={options}
    onSelect={onSelect}
    selectedOption={selectedCurrency}
    label={label}
  />
)

export default CurrencySelect;
